import { healthlabsCommonEnvironment } from '@environments/healthlabs/environment.common';
import { AppEnvironment } from '@models/app-environment';

/**
 * Environment variables for use on the HealthLabs site, in production environment.
 */
export const environment: AppEnvironment = {
  ...healthlabsCommonEnvironment,
  production: true,
  apiUrl: 'https://www.healthlabs.com/simpleCart',
  analyteCareApi: 'https://api.analytecare.com',
  googleMapApiKey: 'AIzaSyD_zZ4q14IkLoRIvw1S-QXpLuCO_g3QDpc',
  braintreeToken: 'production_csgfcd5t_53b8hvj83v98kzmr',
  googlePay: {
    merchantId: 'BCR2DN4TQ3K3DXR3',
    apiVersion: 2,
    apiVersionMinor: 0,
  },
  defaultOrderLabId: '27349',
  oncehubSchedulingUrl: 'https://go.oncehub.com',
  siteUrls: {
    home: 'https://www.healthlabs.com',
    termsOfService: 'https://www.healthlabs.com/terms-of-service',
    myAccount: 'https://my-account.healthlabs.com',
    tests: 'https://www.healthlabs.com',
    notFound: 'https://www.healthlabs.com/404',
  },
};
